module.exports = require('react-declarative-head');
